import useCountry from "./use-country";
import { useFetchEagle } from "./use-fetch";
import { fetchCompletedOrders } from "../../facades/eagle/user";
import { getAndAttachProducts } from "./helpers";

export default () => {
  const { locale } = useCountry();

  return useFetchEagle(fetchCompletedOrders, {
    map: async (response) =>
      await getAndAttachProducts(response.body.data, locale),
  });
};
